export const BRANCHES_LOAD_REQUEST = 'BRANCHES_LOAD_REQUEST';
export const BRANCHES_LOAD_SUCCESS = 'BRANCHES_LOAD_SUCCESS';
export const BRANCHES_LOAD_FAILURE = 'BRANCHES_LOAD_FAILURE';
